import styles from './SearchModal.css'
import InfiniteScroll from 'react-infinite-scroller'
import _ from 'lodash'
const ARROW_UP = 38
const ARROW_DOWN = 40
const ENTER_KEY = 13
const ESC_KEY = 27
class SearchModal extends React.Component {
  constructor (props) {
    super(props)
    this.pagination = false
    this.inputValue = ''
    this.state = {
      isShow: false,
      value: '',
      optionId: 0,
      mouseLeave: true
    }
  }

  render () {
    let {input, options, type, placeholder, readOnly, dis = false, inputClassName, onClickItem, onMenuScrollToBottom, isHasMore, isLoading} = this.props
    let {value, optionId} = this.state
    const { onChange } = input
    const keyOpt = _.mapKeys(options, 'value')
    this.optionsDOM = []
    if (options.length !== 0) {
      this.options = options
    }
    if (this.pagination) {
      isLoading = false
      if (options.length === 0) {
        options = this.options
      }
    }
    return (
      <div className={styles['search-wrapper']}>
        <input
          {...input}
          type={type}
          readOnly={readOnly}
          className={`form-control ${inputClassName}`}
          placeholder={placeholder}
          onChange={this._onChange}
          disabled={dis}
          onBlur={this._onBlur}
          value={keyOpt[value] ? keyOpt[value].label : value}
          onKeyDown={this._onKeyDown}
          ref={(a) => { this.inputDOM = a }}
          autoComplete='off'
        />
        { this.state.isShow &&
          <div
            className={styles['option-list']}
            ref={(a) => {
              this.scrollDOM = a
            }}
            onMouseLeave={() => { this.setState({mouseLeave: true}) }}
            onMouseOver={() => { this.setState({mouseLeave: false}) }}
            onScroll={() => {
              this.inputDOM.focus()
              this.setState({isShow: true})
            }}
            onMouseDown={() => { this.inputDOM.focus() }}
            onMouseUp={() => { this.inputDOM.focus() }}
          >
            <InfiniteScroll
              pageStart={1}
              loadMore={() => {
                this.pagination = true
                onMenuScrollToBottom()
              }}
              useWindow={false}
              hasMore={isHasMore}
              threshold={10}
              initialLoad={false}
            >
              <ul className={styles['list-item']}>
                {options.length === 0 && !isLoading &&
                <li
                  ref={(a) => { let item = {value: 0, dom: a}; this.optionDOM = item }}
                  className={`${styles['item-label']} ${styles['grey-text']}`} value={null}>
                  No results found
                </li>
                }
                {isLoading &&
                <li
                  ref={(a) => { let item = {value: 0, dom: a}; this.optionDOM = item }}
                  className={`${styles['item-label']} ${styles['grey-text']}`} value={null}
                >
                  Searching...
                </li>
                }
                {!isLoading && options.map((option, idx) => {
                  return <a
                    className={`${styles['item-label']} ${optionId === option.value ? styles['selected'] : ''}`}
                    onClick={(e) => {
                      onClickItem(option)
                      this.setState({isShow: false, value: option.value, optionId: option.value})
                      onChange(option.value)
                    }}
                    onMouseOver={() => { this.setState({optionId: option.value}) }}
                    ref={(a) => {
                      let item = {value: option.value, dom: a}
                      if (this.optionsDOM.length < options.length) {
                        if (a) {
                          this.optionsDOM.push(item)
                        }
                      }
                      if (optionId === option.value) {
                        this.optionDOM = item
                      }
                    }
                    }>
                    <li value={option.value}>{option.label}</li>
                  </a>
                })
                }
              </ul>
            </InfiniteScroll>
          </div>
        }
      </div>
    )
  }
  _onBlur = (e) => {
    if (this.state.mouseLeave) {
      this.setState({isShow: false, optionId: 0})
    }
  }

  _onChange = (e) => {
    const nextVal = e.target.value
    this.pagination = false
    this.setState({isShow: true, value: nextVal, optionId: 0})
    if (this.scrollDOM) {
      this.scrollDOM.scrollTop = 0
    }
    const {onInputChange} = this.props
    onInputChange(nextVal)
    this.inputValue = nextVal
  }
  _onKeyDown = (e) => {
    const {optionId} = this.state
    const {onClickItem, input: {onChange}} = this.props
    if (e.keyCode === ARROW_DOWN && this.optionsDOM.length > 0 && optionId === 0) {
      this.setState({isShow: true, optionId: this.optionsDOM[0].value, value: this.optionsDOM[0].value})
      this.optionDOM = this.optionsDOM[0]
    } else {
      this.optionsDOM.forEach((opt, idx) => {
        if (opt.value === optionId) {
          if (idx + 1 < this.optionsDOM.length && e.keyCode === ARROW_DOWN) {
            this.setState({isShow: true, optionId: this.optionsDOM[idx + 1].value, value: this.optionsDOM[idx + 1].value})
            this.optionDOM = this.optionsDOM[idx + 1]
          } else if (idx - 1 >= 0 && e.keyCode === ARROW_UP) {
            this.setState({isShow: true, optionId: this.optionsDOM[idx - 1].value, value: this.optionsDOM[idx - 1].value})
            this.optionDOM = this.optionsDOM[idx - 1]
          }
        }
      })
    }
    if (this.optionDOM && this.optionDOM.dom && this.scrollDOM) {
      const optionDOM = this.optionDOM
      const optionRect = optionDOM.dom.getBoundingClientRect()
      const scrollRect = this.scrollDOM.getBoundingClientRect()
      if (e.keyCode === ARROW_DOWN) {
        if (optionRect.bottom + 31 >= scrollRect.bottom) {
          this.scrollDOM.scrollTop = this.scrollDOM.scrollTop + 31
        }
      } else if (e.keyCode === ARROW_UP) {
        if (optionRect.bottom - 62 <= scrollRect.top) {
          this.scrollDOM.scrollTop = this.scrollDOM.scrollTop === 0 ? 0 : this.scrollDOM.scrollTop - 31
        }
      } else if (e.keyCode === ENTER_KEY) {
        onClickItem(optionDOM)
        e.preventDefault()
        onChange(optionDOM.value)
        this.setState({isShow: false, value: optionDOM.value, optionId: optionDOM.value})
      } else if (e.keyCode === ESC_KEY) {
        this.setState({value: this.inputValue, isShow: false, optionId: 0})
      }
    }
  }
}

export default SearchModal



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SearchModal/SearchModal.js